import PropTypes from "prop-types";

import React from "react";
import { connect } from "react-redux";
import getChapterProgressText from "selectors/navigation/getChapterProgressText";

export function ChapterProgressText(props) {
  return (
    <div className="chapter-progress-text" style={props.style}>
      <span className="chapter-progress-text--copy font-size--copy--small font-style--button-1">
        {props.progressLabel.toUpperCase()}
      </span>
    </div>
  );
}

ChapterProgressText.propTypes = {
  chapterId: PropTypes.number.isRequired,
  progressLabel: PropTypes.string.isRequired,
  style: PropTypes.object,
};

const mapStateToProps = (state, props) => ({
  progressLabel: getChapterProgressText(state, props),
});

export default connect(mapStateToProps)(ChapterProgressText);
